import type { EntryPoint, EntryPointComponent } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const aiSnippetEntryPoint: EntryPoint<
	EntryPointComponent<
		Record<string, never>,
		Record<string, never>,
		{
			cloudId: string;
			contentId: string;
			contentType: string;
			fallbackComponent?: React.ReactNode;
			fallbackText?: string;
			from?: string;
			isHidden?: boolean;
			maxLines?: number;
			onLoadComplete?: () => void;
			showAwareness?: boolean;
			showFooter?: boolean;
			source?: string;
		} & {
			displayName?: string;
			userId?: string;
		},
		Record<string, never>
	>,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "ai-snippet-entrypoint" */ './ui/ai-snippet/ai-snippet-entrypoint'
			),
		{
			moduleId: 'ai-snippet-entrypoint',
		},
	),
	getPreloadProps: () => ({}),
});

export const aiSnippetWithRelayEnvironmentEntryPoint: EntryPoint<
	EntryPointComponent<
		Record<string, never>,
		Record<string, never>,
		{
			cloudId: string;
			contentId: string;
			contentType: string;
			fallbackComponent?: React.ReactNode;
			fallbackText?: string;
			from?: string;
			isHidden?: boolean;
			maxLines?: number;
			onLoadComplete?: () => void;
			showAwareness?: boolean;
			showFooter?: boolean;
			source?: string;
		} & {
			displayName?: string;
			userId?: string;
		},
		Record<string, never>
	>,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "ai-snippet-with-relay-entrypoint" */ './ui/ai-snippet/ai-snippet-with-relay-entrypoint'
			),
		{
			moduleId: 'ai-snippet-with-relay-environment-entrypoint',
		},
	),
	getPreloadProps: () => ({}),
});
